import { PlusSDK } from '@hll/driver-webview-bridge-js/dist/cjs'

export const driverWebviewSdk = new PlusSDK()
